module.exports = __webpack_public_path__ + "static/media/hashtag-nft-2.93779973.jpg";